// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Certificate Print Styles */

.print-certificate-container {
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  padding: 30px;
  margin: 0;
  min-height: 100vh;
}

/* Print Header Controls */
.certificate-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
}

.btn-print,
.btn-close-print {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-print {
  background-color: #1976d2;
  color: white;
}

.btn-print:hover {
  background-color: #1565c0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-close-print {
  background-color: #f44336;
  color: white;
}

.btn-close-print:hover {
  background-color: #d32f2f;
  transform: translateY(-2px);
}

/* Certificate Wrapper */
.certificate-wrapper {
  display: flex;
  justify-content: center;
  background: transparent;
  padding: 0;
  border-radius: 12px;
}

/* Main Certificate */
.certificate {
  width: 8.5in;
  min-height: 11in;
  background: linear-gradient(to bottom, #ffffff 0%, #fafbfc 100%);
  border: 1px solid #e0e7ff;
  border-radius: 12px;
  padding: 50px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);
  position: relative;
  background-image:
    linear-gradient(90deg, rgba(25, 118, 210, 0.01) 1px, transparent 1px),
    linear-gradient(rgba(25, 118, 210, 0.01) 1px, transparent 1px);
  background-size: 50px 50px;
}

/* Header Section */
.certificate-header-section {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 3px solid;
  border-image: linear-gradient(90deg, #1976d2, #42a5f5, #1976d2) 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  position: relative;
}

.certificate-header-section::before {
  content: '';
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.certificate-emblem {
  font-size: 58px;
  margin-bottom: 5px;
  position: relative;
  z-index: 1;
}

.certificate-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.certificate-title p {
  margin: 8px 0 0 0;
  font-size: 15px;
  color: #666;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.certificate-code {
  margin-top: 15px;
  font-size: 13px;
  color: #0d47a1;
  letter-spacing: 2px;
  font-weight: 600;
  font-family: 'Courier New', monospace;
  background: linear-gradient(135deg, #e3f2fd, #f3f6fd);
  padding: 8px 16px;
  border-radius: 4px;
  border-left: 3px solid #1976d2;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 12px 32px;
  border-radius: 25px;
  font-weight: 800;
  font-size: 15px;
  margin: 20px auto;
  letter-spacing: 1.5px;
  text-align: center;
  width: fit-content;
  margin-left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
}

.status-active {
  background: linear-gradient(135deg, #4caf50, #45a049);
  color: white;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.status-pending {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
}

.status-expired {
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);
}

.status-inactive {
  background: linear-gradient(135deg, #9e9e9e, #757575);
  color: white;
  box-shadow: 0 4px 15px rgba(158, 158, 158, 0.3);
}

/* Certificate Body */
.certificate-body {
  margin: 35px 0;
}

.certificate-intro {
  font-size: 14px;
  line-height: 1.9;
  text-align: center;
  margin-bottom: 35px;
  color: #555;
  font-style: italic;
  padding: 20px;
  background: linear-gradient(135deg, #e3f2fd, #f3f6fd);
  border-radius: 8px;
  border-left: 4px solid #1976d2;
}

/* Details Grid */
.details-grid {
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border-bottom: 1px solid #e8e8e8;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-item {
  padding: 16px 20px;
  background: white;
  border-left: 4px solid #1976d2;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: background 0.2s ease;
}

.detail-item:hover {
  background: #f8f9ff;
}

.detail-item label {
  display: block;
  font-size: 10px;
  font-weight: 800;
  color: #1565c0;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
}

.detail-value {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  word-break: break-word;
  line-height: 1.4;
}

/* Validity Section */
.validity-section {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border: 2px solid #ff9800;
  border-radius: 10px;
  padding: 25px;
  margin: 30px 0;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.2);
}

.validity-section h3 {
  margin: 0 0 20px 0;
  color: #e65100;
  font-size: 17px;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.5px;
}

.validity-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.validity-item {
  text-align: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  border: 1px solid #ffe0b2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.validity-item label {
  display: block;
  font-size: 10px;
  font-weight: 800;
  color: #ff9800;
  text-transform: uppercase;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

.validity-date {
  font-size: 17px;
  font-weight: 800;
  color: #e65100;
}

/* Info Sections */
.info-section {
  background: #f9f9f9;
  padding: 15px;
  border-left: 4px solid #1976d2;
  margin: 15px 0;
  border-radius: 2px;
}

.info-section h3 {
  margin: 0 0 10px 0;
  color: #1976d2;
  font-size: 14px;
}

.info-section p {
  margin: 0;
  font-size: 13px;
  color: #555;
  line-height: 1.6;
}

/* Footer Section */
.certificate-footer {
  display: flex;
  justify-content: space-between;
  margin: 30px 0 20px 0;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  font-size: 12px;
}

.footer-left,
.footer-right {
  flex: 1 1;
}

.footer-left p,
.footer-right p {
  margin: 0;
  color: #333;
}

.footer-right {
  text-align: right;
}

/* Signature Section */
.signature-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 40px;
  margin: 40px 0;
  padding: 30px 0;
  text-align: center;
  border-top: 2px solid #e8e8e8;
  border-bottom: 2px solid #e8e8e8;
}

.seal {
  font-size: 72px;
  opacity: 0.25;
  filter: grayscale(100%);
}

.sig-line {
  border-top: 2px solid #1976d2;
  padding-top: 15px;
  min-width: 160px;
}

.sig-line p {
  margin: 0;
  font-size: 12px;
  color: #555;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.sig-box {
  font-size: 13px;
  font-weight: 800;
  color: #1565c0;
  margin-top: 8px;
  letter-spacing: 0.5px;
}

/* Legal Notice */
.legal-notice {
  background: linear-gradient(135deg, #f5f5f5, #fafafa);
  border: 1px solid #e0e0e0;
  padding: 15px;
  border-radius: 6px;
  margin-top: 25px;
  font-size: 10px;
  text-align: center;
  color: #666;
  line-height: 1.6;
  border-left: 4px solid #1976d2;
}

.legal-notice p {
  margin: 0;
}

/* QR Code Section */
.qr-section {
  page-break-inside: avoid;
  margin-top: 30px;
  padding: 25px;
  border: 2px solid #1976d2;
  border-radius: 10px;
  text-align: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3f6fd 100%);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.15);
}

.qr-section h3 {
  color: #0d47a1;
  margin: 0 0 20px 0;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.qr-section .qr-code-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  display: inline-block;
  border: 2px dashed #1976d2;
  margin: 15px 0;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
}

.qr-section .qr-code-container canvas {
  display: block;
  margin: 0 auto;
  border: 2px solid #1976d2;
  border-radius: 4px;
  max-width: 220px;
  height: auto;
}

.qr-section .permit-number {
  margin-top: 12px;
  font-size: 13px;
  color: #1565c0;
  font-weight: 700;
  font-family: 'Courier New', monospace;
}

.qr-section p {
  margin: 10px 0 0 0;
  font-size: 12px;
  color: #0d47a1;
  font-weight: 600;
  line-height: 1.5;
}

/* Print Styles */
@media print {
  .no-print {
    display: none !important;
  }

  .print-certificate-container {
    background: white;
    padding: 0;
    margin: 0;
  }

  .certificate-wrapper {
    background: transparent;
    padding: 0;
    display: block;
  }

  .certificate {
    page-break-inside: avoid;
    box-shadow: none;
    width: 100%;
    height: auto;
    border: 1px solid #e0e7ff;
    background-image: none;
    padding: 40px;
    margin: 0;
    border-radius: 0;
  }

  body,
  html {
    margin: 0;
    padding: 0;
    background: white;
  }

  .certificate-intro {
    page-break-inside: avoid;
  }

  .details-grid {
    page-break-inside: avoid;
  }

  .validity-section {
    page-break-inside: avoid;
  }

  .signature-section {
    page-break-inside: avoid;
  }

  .qr-section {
    page-break-inside: avoid;
    margin-top: 30px;
    padding: 25px;
  }

  @page {
    margin: 0.5in;
    size: letter;
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .certificate {
    width: 100%;
    min-height: auto;
    padding: 20px;
  }

  .detail-row {
    grid-template-columns: 1fr;
  }

  .validity-grid {
    grid-template-columns: 1fr;
  }

  .signature-section {
    gap: 15px;
  }

  .certificate-title h1 {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/certificate.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,WAAW;EACX,6DAA6D;EAC7D,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,gBAAgB;EAChB,gEAAgE;EAChE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0EAA0E;EAC1E,kBAAkB;EAClB;;kEAEgE;EAChE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,iEAAiE;EACjE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,qDAAqD;EACrD,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qDAAqD;EACrD,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,SAAO;AACT;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;;IAEE,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Certificate Print Styles */\n\n.print-certificate-container {\n  width: 100%;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);\n  padding: 30px;\n  margin: 0;\n  min-height: 100vh;\n}\n\n/* Print Header Controls */\n.certificate-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n}\n\n.btn-print,\n.btn-close-print {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-print {\n  background-color: #1976d2;\n  color: white;\n}\n\n.btn-print:hover {\n  background-color: #1565c0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.btn-close-print {\n  background-color: #f44336;\n  color: white;\n}\n\n.btn-close-print:hover {\n  background-color: #d32f2f;\n  transform: translateY(-2px);\n}\n\n/* Certificate Wrapper */\n.certificate-wrapper {\n  display: flex;\n  justify-content: center;\n  background: transparent;\n  padding: 0;\n  border-radius: 12px;\n}\n\n/* Main Certificate */\n.certificate {\n  width: 8.5in;\n  min-height: 11in;\n  background: linear-gradient(to bottom, #ffffff 0%, #fafbfc 100%);\n  border: 1px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 50px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);\n  position: relative;\n  background-image:\n    linear-gradient(90deg, rgba(25, 118, 210, 0.01) 1px, transparent 1px),\n    linear-gradient(rgba(25, 118, 210, 0.01) 1px, transparent 1px);\n  background-size: 50px 50px;\n}\n\n/* Header Section */\n.certificate-header-section {\n  text-align: center;\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n  border-bottom: 3px solid;\n  border-image: linear-gradient(90deg, #1976d2, #42a5f5, #1976d2) 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  position: relative;\n}\n\n.certificate-header-section::before {\n  content: '';\n  position: absolute;\n  top: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #1976d2, #42a5f5);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);\n}\n\n.certificate-emblem {\n  font-size: 58px;\n  margin-bottom: 5px;\n  position: relative;\n  z-index: 1;\n}\n\n.certificate-title h1 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n.certificate-title p {\n  margin: 8px 0 0 0;\n  font-size: 15px;\n  color: #666;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.certificate-code {\n  margin-top: 15px;\n  font-size: 13px;\n  color: #0d47a1;\n  letter-spacing: 2px;\n  font-weight: 600;\n  font-family: 'Courier New', monospace;\n  background: linear-gradient(135deg, #e3f2fd, #f3f6fd);\n  padding: 8px 16px;\n  border-radius: 4px;\n  border-left: 3px solid #1976d2;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 12px 32px;\n  border-radius: 25px;\n  font-weight: 800;\n  font-size: 15px;\n  margin: 20px auto;\n  letter-spacing: 1.5px;\n  text-align: center;\n  width: fit-content;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n}\n\n.status-active {\n  background: linear-gradient(135deg, #4caf50, #45a049);\n  color: white;\n  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);\n}\n\n.status-pending {\n  background: linear-gradient(135deg, #ff9800, #f57c00);\n  color: white;\n  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);\n}\n\n.status-expired {\n  background: linear-gradient(135deg, #f44336, #d32f2f);\n  color: white;\n  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);\n}\n\n.status-inactive {\n  background: linear-gradient(135deg, #9e9e9e, #757575);\n  color: white;\n  box-shadow: 0 4px 15px rgba(158, 158, 158, 0.3);\n}\n\n/* Certificate Body */\n.certificate-body {\n  margin: 35px 0;\n}\n\n.certificate-intro {\n  font-size: 14px;\n  line-height: 1.9;\n  text-align: center;\n  margin-bottom: 35px;\n  color: #555;\n  font-style: italic;\n  padding: 20px;\n  background: linear-gradient(135deg, #e3f2fd, #f3f6fd);\n  border-radius: 8px;\n  border-left: 4px solid #1976d2;\n}\n\n/* Details Grid */\n.details-grid {\n  margin: 30px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.detail-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-item {\n  padding: 16px 20px;\n  background: white;\n  border-left: 4px solid #1976d2;\n  border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: background 0.2s ease;\n}\n\n.detail-item:hover {\n  background: #f8f9ff;\n}\n\n.detail-item label {\n  display: block;\n  font-size: 10px;\n  font-weight: 800;\n  color: #1565c0;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin-bottom: 8px;\n}\n\n.detail-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n/* Validity Section */\n.validity-section {\n  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n  border: 2px solid #ff9800;\n  border-radius: 10px;\n  padding: 25px;\n  margin: 30px 0;\n  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.2);\n}\n\n.validity-section h3 {\n  margin: 0 0 20px 0;\n  color: #e65100;\n  font-size: 17px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  letter-spacing: 0.5px;\n}\n\n.validity-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.validity-item {\n  text-align: center;\n  padding: 15px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #ffe0b2;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.validity-item label {\n  display: block;\n  font-size: 10px;\n  font-weight: 800;\n  color: #ff9800;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  letter-spacing: 1px;\n}\n\n.validity-date {\n  font-size: 17px;\n  font-weight: 800;\n  color: #e65100;\n}\n\n/* Info Sections */\n.info-section {\n  background: #f9f9f9;\n  padding: 15px;\n  border-left: 4px solid #1976d2;\n  margin: 15px 0;\n  border-radius: 2px;\n}\n\n.info-section h3 {\n  margin: 0 0 10px 0;\n  color: #1976d2;\n  font-size: 14px;\n}\n\n.info-section p {\n  margin: 0;\n  font-size: 13px;\n  color: #555;\n  line-height: 1.6;\n}\n\n/* Footer Section */\n.certificate-footer {\n  display: flex;\n  justify-content: space-between;\n  margin: 30px 0 20px 0;\n  padding-top: 20px;\n  border-top: 1px solid #ddd;\n  font-size: 12px;\n}\n\n.footer-left,\n.footer-right {\n  flex: 1;\n}\n\n.footer-left p,\n.footer-right p {\n  margin: 0;\n  color: #333;\n}\n\n.footer-right {\n  text-align: right;\n}\n\n/* Signature Section */\n.signature-section {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 40px;\n  margin: 40px 0;\n  padding: 30px 0;\n  text-align: center;\n  border-top: 2px solid #e8e8e8;\n  border-bottom: 2px solid #e8e8e8;\n}\n\n.seal {\n  font-size: 72px;\n  opacity: 0.25;\n  filter: grayscale(100%);\n}\n\n.sig-line {\n  border-top: 2px solid #1976d2;\n  padding-top: 15px;\n  min-width: 160px;\n}\n\n.sig-line p {\n  margin: 0;\n  font-size: 12px;\n  color: #555;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.sig-box {\n  font-size: 13px;\n  font-weight: 800;\n  color: #1565c0;\n  margin-top: 8px;\n  letter-spacing: 0.5px;\n}\n\n/* Legal Notice */\n.legal-notice {\n  background: linear-gradient(135deg, #f5f5f5, #fafafa);\n  border: 1px solid #e0e0e0;\n  padding: 15px;\n  border-radius: 6px;\n  margin-top: 25px;\n  font-size: 10px;\n  text-align: center;\n  color: #666;\n  line-height: 1.6;\n  border-left: 4px solid #1976d2;\n}\n\n.legal-notice p {\n  margin: 0;\n}\n\n/* QR Code Section */\n.qr-section {\n  page-break-inside: avoid;\n  margin-top: 30px;\n  padding: 25px;\n  border: 2px solid #1976d2;\n  border-radius: 10px;\n  text-align: center;\n  background: linear-gradient(135deg, #e3f2fd 0%, #f3f6fd 100%);\n  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.15);\n}\n\n.qr-section h3 {\n  color: #0d47a1;\n  margin: 0 0 20px 0;\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.qr-section .qr-code-container {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  display: inline-block;\n  border: 2px dashed #1976d2;\n  margin: 15px 0;\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);\n}\n\n.qr-section .qr-code-container canvas {\n  display: block;\n  margin: 0 auto;\n  border: 2px solid #1976d2;\n  border-radius: 4px;\n  max-width: 220px;\n  height: auto;\n}\n\n.qr-section .permit-number {\n  margin-top: 12px;\n  font-size: 13px;\n  color: #1565c0;\n  font-weight: 700;\n  font-family: 'Courier New', monospace;\n}\n\n.qr-section p {\n  margin: 10px 0 0 0;\n  font-size: 12px;\n  color: #0d47a1;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n/* Print Styles */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .print-certificate-container {\n    background: white;\n    padding: 0;\n    margin: 0;\n  }\n\n  .certificate-wrapper {\n    background: transparent;\n    padding: 0;\n    display: block;\n  }\n\n  .certificate {\n    page-break-inside: avoid;\n    box-shadow: none;\n    width: 100%;\n    height: auto;\n    border: 1px solid #e0e7ff;\n    background-image: none;\n    padding: 40px;\n    margin: 0;\n    border-radius: 0;\n  }\n\n  body,\n  html {\n    margin: 0;\n    padding: 0;\n    background: white;\n  }\n\n  .certificate-intro {\n    page-break-inside: avoid;\n  }\n\n  .details-grid {\n    page-break-inside: avoid;\n  }\n\n  .validity-section {\n    page-break-inside: avoid;\n  }\n\n  .signature-section {\n    page-break-inside: avoid;\n  }\n\n  .qr-section {\n    page-break-inside: avoid;\n    margin-top: 30px;\n    padding: 25px;\n  }\n\n  @page {\n    margin: 0.5in;\n    size: letter;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .certificate {\n    width: 100%;\n    min-height: auto;\n    padding: 20px;\n  }\n\n  .detail-row {\n    grid-template-columns: 1fr;\n  }\n\n  .validity-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .signature-section {\n    gap: 15px;\n  }\n\n  .certificate-title h1 {\n    font-size: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
